angular.module('accordion', ['ngAnimate'])

  .directive('accordion', () => ({
    scope: true,
    link: function (scope, element, attrs) {

      // Index of the accordion currently opened (-1 for none)
      let open = attrs.open || -1;

      /**
       * Open of close a given accordion.
       * @param index Index of the accordion to toggle
       */
      scope.toggleAccordion = function (index) {
        open = (open == index ? -1 : index);
      };

      /**
       * @param index Index of the accordion
       * @returns {boolean} true if the given accordion is open.
       */
      scope.isAccordionOpen = function (index) {
        return index == open;
      };
    }
  }))

  .animation('.accordion-body', function () {
    const NG_HIDE_CLASS = 'ng-hide';
    return {
      beforeAddClass: function (element, className, done) {
        if (className === NG_HIDE_CLASS) {
          element.slideUp(done);
        }
      },
      removeClass: function (element, className, done) {
        if (className === NG_HIDE_CLASS) {
          element.hide().slideDown(done);
        }
      }
    }
  });
angular.module('twoLines', [])

  .directive('twoLines', () => {
    return {
      scope: {
        target: '='
      },
      replace: true,
      template: `
<div class="hashValue">
{{ target.slice(0, target.length / 2) }}
<br>
{{ target.slice(-(target.length / 2)) }}
</div>`,
    };
  });

angular.module('identity', [])

  .directive('identity', () => {
    return {
      scope: {
        target: '='
      },
      replace: true,
      template: `
<div class="identityValue">
{{ target }}
</div>`,
    };
  });

"use strict";

/**
 * @namespace angular
 */

/**
 * @typedef {Object}        ValidationAnchor
 * @typedef {Number}        ValidationAnchor.created
 * @typedef {Number}        ValidationAnchor.lastModified
 * @typedef {Number}        ValidationAnchor.timestamp
 * @typedef {String}        ValidationAnchor.status
 * @typedef {String}        ValidationAnchor.hash
 * @typedef {String}        ValidationAnchor.signedHash
 * @typedef {String}        ValidationAnchor.signature
 * @typedef {String}        ValidationAnchor.name
 * @typedef {String}        ValidationAnchor.id
 * @typedef {Boolean}       ValidationAnchor.public
 * @typedef {Array<String>} ValidationAnchor.tags
 * @typedef {Array<Object>} ValidationAnchor.metadata
 */

/**
 * @typedef {Object} ValidationTransaction
 * @typedef {String} ValidationTransaction.tx_id
 * @typedef {Number} ValidationTransaction.confirmations
 * @typedef {Number} ValidationTransaction.confirmedAt
 * @typedef {String} ValidationTransaction.blockHash
 * @typedef {String} ValidationTransaction.opReturn
 */

/**
 * @typedef {Object} HashedFile
 * @typedef {String} HashedFile.name
 * @typedef {String} HashedFile.hash
 * @typedef {Number} HashedFile.progress
 */

/**
 * @typedef {Object} IdentityVerificationElement
 * @typedef {String} IdentityVerificationElement.C  country
 * @typedef {String} IdentityVerificationElement.CN domain
 * @typedef {Number} IdentityVerificationElement.L  locality
 * @typedef {Number} IdentityVerificationElement.O  organisation
 * @typedef {Number} IdentityVerificationElement.ST state
 */

/**
 * @typedef {Object} IdentityVerificationCertificate
 * @typedef {IdentityVerificationElement} IdentityVerificationCertificate.subject
 * @typedef {IdentityVerificationElement} IdentityVerificationCertificate.issuer
 */

/**
 * @typedef {Object} IdentityVerificationStatus
 * @typedef Array<IdentityVerificationCertificate> IdentityVerificationStatus.certificates
 * @typedef {String} IdentityVerificationStatus.code
 * @typedef {String} IdentityVerificationStatus.text
 * @typedef {Object} IdentityVerificationStatus.identity
 * @typedef {Object} IdentityVerificationStatus.signedIdentity
 */

/**
 * @typedef {Object} ReceiptValidation
 * @typedef {String} ReceiptValidation.code
 * @typedef {String} ReceiptValidation.text
 * @typedef {Number} ReceiptValidation.timestamp
 * @typedef {Number} ReceiptValidation.confirmations
 * @typedef {IdentityVerificationStatus} ReceiptValidation.identityVerificationStatus
 */

/**
 * @typedef {Object}                ValidationData
 * @typedef {ValidationAnchor}      ValidationData.anchor
 * @typedef {Receipt}               ValidationData.receipt
 * @typedef {ValidationTransaction} ValidationData.validation
 * @typedef {AlertInstance}         ValidationData.alert
 * @typedef {boolean}               ValidationData.hide
 */

/**
 * @typedef {Object}            ValidationContext
 * @typedef {HashedFile}        ValidationContext.file
 * @typedef {ValidationData}    ValidationContext.userData
 * @typedef {ValidationData[]}  ValidationContext.serverData
 */

/**
 * @typedef {Object}   Receipt
 * @typedef {Object}   Receipt.header
 * @typedef {String}   Receipt.header.chainpoint_version
 * @typedef {String}   Receipt.header.hash_type
 * @typedef {String}   Receipt.header.merkle_root
 * @typedef {String}   Receipt.header.tx_id
 * @typedef {Number}   Receipt.header.timestamp
 * @typedef {Object}   Receipt.signature
 * @typedef {String}   Receipt.signature.signedHash
 * @typedef {String}   Receipt.signature.pubKey
 * @typedef {String}   Receipt.signature.signature
 * @typedef {String}   Receipt.signature.identityURL
 * @typedef {Object}   Receipt.target
 * @typedef {String}   Receipt.target.target_hash
 * @typedef {String}   Receipt.target.target_URI
 * @typedef {Object[]} Receipt.target.target_proof
 */

/**
 * @typedef object     PrunedBranch
 * @typedef string     PrunedBranch.left
 * @typedef string     PrunedBranch.right
 */

/**
 * @typedef object     AnchorV2
 * @typedef string     AnchorV2.type
 * @typedef string     AnchorV2.sourceId
 */

/**
 * @typedef object          ReceiptV2
 * @typedef string          ReceiptV2.@context
 * @typedef string          ReceiptV2.type
 * @typedef string          ReceiptV2.MerkleRoot
 * @typedef string          ReceiptV2.targetHash
 * @typedef PrunedBranch[]  ReceiptV2.proof
 * @typedef AnchorV2[]      ReceiptV2.anchors
 */

angular.module('checkFileTemplate', ['api', 'twoLines', 'identity', 'accordion', 'translation'])

  .directive('checkFileElement', (api, getReceiptFileHash, getReceiptTargetHash, getReceiptTxId) => ({
    restrict: 'E',
    templateUrl: '/resources/modules/checkFile/checkFileElementTemplate.html',
    scope: {
      'element': '=',
      'name': '='
    },
    link: function (scope) {

      scope.getReceiptFileHash = getReceiptFileHash;
      scope.getReceiptTargetHash = getReceiptTargetHash;
      scope.getReceiptTxId = getReceiptTxId;

      scope.$watch('element', setElementValues, true);

      /**
       * @param {{alert: AlertInstance, receipt: Receipt, anchor: ValidationAnchor, validation: ValidationTransaction}} element
       */
      function setElementValues(element) {

        /** @type {AlertInstance} */
        scope.alert = element.alert;

        /** @type {Receipt} */
        const receipt = scope.receipt = element.receipt;

        /** @type {ValidationAnchor} */
        const anchor = scope.anchor = element.anchor;

        /** @type {ValidationTransaction} */
        scope.validation = element.validation;

        scope.signature = (receipt && receipt.signature) || null;

        /** @type {IdentityVerificationStatus} */
        scope.identityVerificationStatus = scope.validation ? scope.validation.identityVerificationStatus : null;
        if (scope.identityVerificationStatus) {
          scope.identity = scope.identityVerificationStatus.identity;
          scope.signedIdentity = scope.identityVerificationStatus.signedIdentity;
        }
      }

      scope.getFullIdentityURL = () => scope.signature &&
        (scope.signature.identityURL
          + '?pubKey=' + scope.signature.pubKey
          + (scope.signature.signedIdentity ?
            '&signedIdentity=' + encodeURIComponent(scope.signature.signedIdentity) : "")
          + '&leftData=random');

      scope.downloadReceipt = () => {
        if (!scope.anchor) return;
        api.anchors.downloadReceipt(scope.anchor);
      };

      scope.downloadReceiptFromJSON = () => {
        if (!scope.receipt) return;

        // The receipt name is (in order of preference):
        // - the anchor name (if an anchor object is available in the scope)
        // - the <check-file-element> name attribute
        // - the hash of the file
        const name = (scope.anchor && scope.anchor.name) || scope.name || getReceiptFileHash(scope.receipt);
        api.downloadJSON(name + '_proof_receipt.json', scope.receipt);
      };

      scope.platform = api.env.platform();
    }
  }))

  .directive('checkFileElementList', () => ({
    restrict: 'E',
    templateUrl: '/resources/modules/checkFile/checkFileElementListTemplate.html',
    scope: {
      'data': '=',
      'show': '=',
      'name': '=',
      'open': '='
    },

    link: function (scope) {

      // Get the type of alert to display an element
      scope.getType = (element) => {
        return (
          element.validation
          && element.validation.identityVerificationStatus
          && element.validation.identityVerificationStatus.code !== 'VERIFIED' ?
            'warning' : element.alert.type
        ) || 'info';
      };
    }
  }))

  .factory('getReceiptTargetHash', () => (receipt) => {
    if (!receipt) return null;
    return (receipt.target && receipt.target.target_hash.toLowerCase()) // Chainpoint v1
      || receipt.targetHash.toLowerCase(); // Chanpoint v2
  })

  .factory('getReceiptFileHash', () => (receipt) => {
    if (!receipt) return null;
    return (receipt.signature && receipt.signature.signedHash) // Signature receipt
      || (receipt.target && receipt.target.target_hash.toLowerCase()) // Chainpoint v1
      || receipt.targetHash.toLowerCase(); // Chainpoint v2
  })

  .factory('getReceiptTxId', () => (receipt) => {
    if (!receipt) return null;
    if (receipt.header) {
      return receipt.header.tx_id || null;
    } else {
      return receipt.anchors && receipt.anchors.length && receipt.anchors.find((a) => a.type === 'BTCOpReturn').sourceId || null;
    }
  })

  .factory('getValidationStatus', () =>

    /**
     * @param {ReceiptValidation} validation
     * @returns {string}
     */
    function getValidationStatus(validation) {
      switch (validation.code) {
        case 'VERIFIED':
          if (validation.identityVerificationStatus
            && validation.identityVerificationStatus.code !== 'VERIFIED')
            return 'warning';
          return 'success';
        case 'TX_NOT_CONFIRMED':
        case 'TX_NOT_SENT':
          return 'warning';
        default:
          return 'danger';
      }
    })

  .factory('getValidationMessage', ($filter, translate) =>

    /**
     * @param {Receipt} receipt
     * @param {ReceiptValidation} validation
     * @returns {string}
     */
    function getValidationMessage(receipt, validation) {
      if (validation.code === 'VERIFIED') {
        if (!receipt.signature)
          return translate("timestamped_on") + ' ' + $filter('time')(validation.timestamp);
        let message = receipt.signature.signatureRequestURL ? translate("signed_on") : translate("seald_on");
        message += ' ' + $filter('time')(validation.timestamp);
        message += ' ' + translate('by') + ' ';
        let ids = validation.identityVerificationStatus;
        if (ids && ids.signedIdentity && ids.signedIdentity.commonName) {
          message += ids.signedIdentity.commonName;
        } else if (ids && ids.identity && ids.identity.commonName) {
          message += ids.identity.commonName;
        } else if (ids && ids.certificates && ids.certificates.length) {
          let cert = ids.certificates[0];
          message += cert.subject.O || cert.subject.CN;
        } else
          message += translate('the_bitcoin_address') + ' ' + receipt.signature.pubKey;
        return message;
      } else {
        return translate(validation.code.toLowerCase());
      }
    });

"use strict";

/**
 * @namespace angular
 */

function getNavigatorLanguage() {
  // navigator.languages returns something like ["en-US", "en", "fr-FR", "fr"]
  // navigator.language return something like "fr"
  // we want an array of languages like ["en", "fr"]
  const languages = (navigator.languages || [])
    .concat(navigator.language || navigator.userLanguage)
    .map((e) => e.split('-')[0]) // keep only the string before "-"
    .filter((e, i, arr) => arr.indexOf(e) == i) // drop doubles
    .filter(lang => lang == 'fr' || lang == 'en'); // drop unsupported languages

  return languages.length > 0 ? languages[0] : 'en';
}

angular.module('translation', ['pascalprecht.translate', 'ngSanitize', 'angular-momentjs'])
  .config(["$translateProvider", (provider) => {
    provider.useStaticFilesLoader({
      prefix: '/resources/modules/translation/',
      suffix: '.json'
    });

    provider.preferredLanguage(getNavigatorLanguage());
    provider.fallbackLanguage('en');

    // This strategy escapes html within translation strings. It yields a warning when disabled.
    //provider.useSanitizeValueStrategy('escape');
  }])
  .factory('translationConfig', ($translate, $moment) => {

    // List of languages currently supported by the app
    const supportedLanguages = ['fr', 'en'];

    // Language set in the browser
    const navigatorLanguage = getNavigatorLanguage();

    // Set default app language to browser language
    let currentLanguage = navigatorLanguage;

    /**
     * Given a requested language, return the fallback language to use.
     * @param {key} requested language
     * @returns {string} fallback language
     */
    const getFallbackLanguage = (key) => supportedLanguages.indexOf(key) != -1 ? key : navigatorLanguage;

    return {
      getSupportedLanguages: () => supportedLanguages,
      getNavigatorLanguage,
      getCurrentLanguage: () => currentLanguage,
      setLanguage: (key, cb) => {
        // callback with supported lang
        key = getFallbackLanguage(key);
        $translate.use(key);
        $moment.locale(key);
        currentLanguage = key;
        if (cb) cb(key);
      },
      changeLanguage: (key, cb) => {
        currentLanguage = key;
        // callback with supported language
        if (cb) cb(getFallbackLanguage(key));
      }
    }
  })
  .factory('translate', ($filter) => $filter('translate'));